import Routes from "./routes";
import AuthProvider from "./provider/authProvider";
import { ColorModeProvider } from "./provider/colorModeProvider";

function App() {
  return (
    <ColorModeProvider>
      <AuthProvider>
        <Routes/>
      </AuthProvider>
    </ColorModeProvider>
  );
}


export default App;
